import React, {Component} from 'react';
import withStyles from "@material-ui/core/styles/withStyles";
import Typography from "@material-ui/core/Typography/index";
import {Color} from './../utis/Styles'
import {MobileChatType} from "../utis/customEnum";
import Button from "@material-ui/core/Button";
import {languagePackage} from "../utis/localStrings"

class ChatStatus extends Component{
	static defaultProps = {
		chatType: MobileChatType.invite,
		peerName: '',
		title: 'Invite',
		counting: false,
		isPatientRole: true
	}

	renderPatientViewOfflineContent() {
		const { classes } = this.props

		return (
			<Typography className={classes.patientTitle}>
				{languagePackage().WaitForDoctorOnline}
			</Typography>
		)
	}

	renderPatientViewCallDoctorButton() {
		const { classes } = this.props
		let chatType = this.props.chatType
		let peerName = this.props.peerName

		return(
			<Button onClick={() => {
				this.props.clickAction && this.props.clickAction(chatType, peerName)
			}} className={classes.callButton} color="primary">
				<img style={{width: 20, height: 18, marginRight: 8,}} src={require('../assets/images/phone_call.png')} alt={""}/>

				<Typography className={classes.baseButton}>
					{languagePackage().Call}
				</Typography>
			</Button>
		)
	}

	renderPatientContent() {
		const { classes } = this.props
		let chatType = this.props.chatType
		let peerName = this.props.peerName


		return (
			<React.Fragment>
				<img style={{width: 72, height: 100}} src={chatType === MobileChatType.invite ? require('../assets/images/doctor_offline.png') : require('../assets/images/doctor_online.png')} alt={""}/>

				<Typography className={classes.doctorNameTitle}>
					{peerName}
				</Typography>

				{chatType === MobileChatType.invite ? this.renderPatientViewOfflineContent() : this.renderPatientViewCallDoctorButton()}
			</React.Fragment>
		)
	}

	renderDoctorViewCallDoctorButton() {
		const { classes } = this.props
		let chatType = this.props.chatType
		let peerName = this.props.peerName
		let title = this.props.title
		let counting = this.props.counting

		return(
			<Button disabled={counting} onClick={() => {
				if (!counting) {
					this.props.clickAction && this.props.clickAction(chatType, peerName)
				}
			}} className={counting ? classes.callButtonDisable : classes.callButton} color="primary">

				{counting ?
					(<Typography className={classes.countTitle}>
					{title}
					</Typography>) :
					(<React.Fragment>
						<img style={{width: 19, height: 20, marginRight: 8,}} src={chatType === MobileChatType.invite? require('../assets/images/invite.png') : require('../assets/images/phone_call.png')} alt={""}/>
						<Typography className={classes.baseButton}>
							{chatType === MobileChatType.invite ? languagePackage().Invite : languagePackage().Call}
						</Typography>
				</React.Fragment>)}

			</Button>
		)
	}

	renderDoctorContent() {
		const { classes } = this.props
		let chatType = this.props.chatType
		let peerName = this.props.peerName

		return (
			<React.Fragment>
				<img style={{width: 96, height: 100}} src={chatType === MobileChatType.invite ? require('../assets/images/patient_offline.png') : require('../assets/images/patient_online.png')} alt={""}/>

				<Typography className={classes.doctorNameTitle}>
					{peerName}
				</Typography>

				{this.renderDoctorViewCallDoctorButton()}

			</React.Fragment>
		)
	}

	render() {
		const { classes } = this.props
		let isPatientRole = this.props.isPatientRole

		return(
			<div className={classes.root}>
				<div className={classes.container}>
					{isPatientRole  ? this.renderPatientContent() : this.renderDoctorContent()}
				</div>
			</div>
		)
	}
}

const styles = (theme) => ({
	root: {
		width: '100%',
		height: '100%',
		backgroundColor: '#ffff00',
		position: 'absolute',
		left: 0,
		right: 0,
		top: 0,
		bottom: 0,
	},
	container: {
		height: '100%',
		display: 'flex',
		backgroundColor: '#ffffff',
		flexDirection: 'column',
		justifyContent: 'center',
		alignItems: 'center'
	},
	bar: {
		width: '100%',
		position: 'absolute',
		left: 0,
		top: 0,
	},
	actionButton: {
		maxWidth: '90%',
		minHeight: 50,
		minWidth: 100,
		backgroundColor: Color.theme,
		color: Color.white,
		fontSize: 18,
	},
	actionButtonCounting: {
		maxWidth: '90%',
		height: 50,
		minWidth: 100,
		backgroundColor: Color.lightGray,
		color: Color.white,
		fontSize: 18,
	},
	title: {
		color: Color.white
	},
	patientTitle: {
		color: Color.black,
		maxWidth: '70%',
		textAlign: 'center',
		fontSize: 18,
	},
	doctorNameTitle: {
		fontSize: 18,
		color: Color.lightGray,
		marginTop: 16,
		marginBottom: 30
	},
	callButton: {
		display: 'flex',
		flexDirection: 'row',
		alignItems: 'center',
		justifyContent: 'center',
		width: 200,
		backgroundColor: Color.theme,
		color: Color.white,
		fontSize: 20,
		height: 50,
	},
	callButtonDisable: {
		display: 'flex',
		flexDirection: 'row',
		alignItems: 'center',
		justifyContent: 'center',
		width: 200,
		backgroundColor: Color.lightGray,
		color: Color.white,
		fontSize: 20,
		height: 50,
	},
	baseButton: {
		fontSize: 20
	},
	countTitle: {
		color: Color.white,
		fontSize: 20,
	}
})

export default withStyles(styles)(ChatStatus)
